// @ts-ignore
import {IOrderTrueDriverDateFrequencyState} from "./states/IOrderTrueDriverDateFrequencyState.interface";
import {SelectPredefinedOptions} from "../interfaces/enums/SelectPredefinedOptions.enum";

const orderTrueDriverDateFrequency = {
    prefix: 'orderTrueDriverDate.',
    namespaced: true,
    state: <IOrderTrueDriverDateFrequencyState>{
        selectedPredefinedOption: SelectPredefinedOptions.CHOOSE,
        period: 1,
        selectedPeriodType: null,
        selectedDays: null,
        firstSelectedDay: null,
        selectedStartDate: null,
        nthSelectedDay: null,
        selectedEndDate: null,
        translatedSelectedDateText: null,
    },

    mutations: {
        INITIALIZE_TRUE_DRIVER_DATE_STATE(state: IOrderTrueDriverDateFrequencyState): void {
            state['defaultState'] = {...state};

            for (const prop of Object.getOwnPropertyNames(state)) {

                let value = localStorage.getItem(orderTrueDriverDateFrequency.prefix + prop);

                if (value) {
                    value = JSON.parse(value);
                    switch (prop) {
                        case 'selectedStartDate':
                        case 'selectedEndDate':
                            // @ts-ignore
                            value = new Date(value);
                            break;
                    }
                    state[prop] = value;
                }
            }
        },

        SET_STATE_PROP_VALUE(state: IOrderTrueDriverDateFrequencyState, payload: {prop: string, value: any}[]): void {
            for (const obj of payload) {
                if (! state.hasOwnProperty(obj.prop)) {
                    console.error('Trying to set state prop that doesn\'t exist');
                    return;
                }
            }

            for (const obj of payload) {
                const prop = obj.prop;
                let value = obj.value;

                // Ensure props to be converted to object accordingly
                switch (prop) {
                    case 'selectedStartDate':
                    case 'selectedEndDate':
                        if (typeof value !== 'object') {
                            // @ts-ignore
                            value = new Date(value);
                        }
                        break;
                }

                state[prop] = value;

                localStorage.removeItem(orderTrueDriverDateFrequency.prefix + prop);

                if (value !== undefined) {
                    localStorage.setItem(orderTrueDriverDateFrequency.prefix + prop, value ? JSON.stringify(value) : value);
                }
            }
        },

        RESET_STATE_PROPS_VALUES(state: IOrderTrueDriverDateFrequencyState): void {
            const stateKeys = Object.keys(state);

            for (const key of stateKeys) {

                if (key === 'period') {

                    state[key] = 1;

                } else if (key === 'selectedPredefinedOption') {

                    state[key] = SelectPredefinedOptions.NOT_REPEAT;

                } else {

                    state[key] = null;

                }
            }
        },

        CLEAR_STATE(state: IOrderTrueDriverDateFrequencyState): void {
            for (const prop of Object.getOwnPropertyNames(state)) {
                localStorage.removeItem(orderTrueDriverDateFrequency.prefix + prop);

                if (state.defaultState) {
                    state[prop] = state.defaultState[prop];
                }
            }
        }
    },

    actions: {
        updateState(context, data: {prop: string, value: any}[]): void {
            context.commit('SET_STATE_PROP_VALUE', data);
        },

        resetAllStateKeys(context) {
            context.commit('RESET_STATE_PROPS_VALUES');
        },

        initState(context) {
            context.commit('INITIALIZE_TRUE_DRIVER_DATE_STATE');
        }


    },

    getters: {

    }
}

export default orderTrueDriverDateFrequency;